module.exports = __webpack_public_path__ + "static/img/fish15.8f903b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/jingdianfish/fish15.png
// module id = sADf
// module chunks = 0